/**
 * MSK Posture Reducers
 */
 import {
    ALL_MSKPOSTURE,
    ADD_MSKPOSTURE,
    MSKPOSTURE_ACTION,
    EDIT_MSKPOSTURE,
    STATUS_MSKPOSTURE,
    DELETE_MSKPOSTURE,
    ALL_SHOULDERPOSTURE,
    ADD_SHOULDERPOSTURE,
    EDIT_SHOULDERPOSTURE,
    STATUS_SHOULDERPOSTURE,
    DELETE_SHOULDERPOSTURE,
    ALL_THORACICPOSTURE,
    ADD_THORACICPOSTURE,
    EDIT_THORACICPOSTURE,
    STATUS_THORACICPOSTURE,
    DELETE_THORACICPOSTURE,
    ALL_LUMBARPOSTURE,
    ADD_LUMBARPOSTURE,
    EDIT_LUMBARPOSTURE,
    STATUS_LUMBARPOSTURE,
    DELETE_LUMBARPOSTURE,
    ALL_PELVISPOSTURE,
    ADD_PELVISPOSTURE,
    EDIT_PELVISPOSTURE,
    STATUS_PELVISPOSTURE,
    DELETE_PELVISPOSTURE,
    ALL_KNEEPOSTURE,
    ADD_KNEEPOSTURE,
    EDIT_KNEEPOSTURE,
    STATUS_KNEEPOSTURE,
    DELETE_KNEEPOSTURE,
    ALL_FEETPOSTURE,
    ADD_FEETPOSTURE,
    EDIT_FEETPOSTURE,
    STATUS_FEETPOSTURE,
    DELETE_FEETPOSTURE,
    ALL_RHYTHMPOSTURE,
    ADD_RHYTHMPOSTURE,
    EDIT_RHYTHMPOSTURE,
    STATUS_RHYTHMPOSTURE,
    DELETE_RHYTHMPOSTURE,
    ALL_ABBREVIATIONPOSTURE,
    ADD_ABBREVIATIONPOSTURE,
    EDIT_ABBREVIATIONPOSTURE,
    STATUS_ABBREVIATIONPOSTURE,
    DELETE_ABBREVIATIONPOSTURE
 } from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    mksheadlists:[],
    mkshoulderlists:[],
    mkthoraciclists:[],
    mklumbarlists:[],
    mkpelvislists:[],
    mkkneelists:[],
    mkfeetlists:[],
    mkrythmlists:[],
    mkabbreviationlists:[],
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case MSKPOSTURE_ACTION:
            return { ...state, loading: true };

        case ALL_MSKPOSTURE:
            return { ...state, loading: false, mksheadlists: action.payload };  
            
        case ADD_MSKPOSTURE:
            return { ...state, loading: false }; 
        
        case EDIT_MSKPOSTURE:
            return { ...state, loading: false };  
        
        case STATUS_MSKPOSTURE:
            return { ...state, loading: false };    
        
        case DELETE_MSKPOSTURE:
            return { ...state, loading: false };
        
        case ALL_SHOULDERPOSTURE:
            return { ...state, loading: false, mkshoulderlists: action.payload };  
            
        case ADD_SHOULDERPOSTURE:
            return { ...state, loading: false }; 
        
        case EDIT_SHOULDERPOSTURE:
            return { ...state, loading: false };  
        
        case STATUS_SHOULDERPOSTURE:
            return { ...state, loading: false };    
        
        case DELETE_SHOULDERPOSTURE:
            return { ...state, loading: false };  
            
        case ALL_THORACICPOSTURE:
            return { ...state, loading: false, mkthoraciclists: action.payload };  
            
        case ADD_THORACICPOSTURE:
            return { ...state, loading: false }; 
        
        case EDIT_THORACICPOSTURE:
            return { ...state, loading: false };  
        
        case STATUS_THORACICPOSTURE:
            return { ...state, loading: false };    
        
        case DELETE_THORACICPOSTURE:
            return { ...state, loading: false };  
            
        case ALL_LUMBARPOSTURE:
            return { ...state, loading: false, mklumbarlists: action.payload };  
            
        case ADD_LUMBARPOSTURE:
            return { ...state, loading: false }; 
        
        case EDIT_LUMBARPOSTURE:
            return { ...state, loading: false };  
        
        case STATUS_LUMBARPOSTURE:
            return { ...state, loading: false };    
        
        case DELETE_LUMBARPOSTURE:
            return { ...state, loading: false };   
            
        case ALL_PELVISPOSTURE:
        return { ...state, loading: false, mkpelvislists: action.payload };  
            
        case ADD_PELVISPOSTURE:
            return { ...state, loading: false }; 
        
        case EDIT_PELVISPOSTURE:
            return { ...state, loading: false };  
        
        case STATUS_PELVISPOSTURE:
            return { ...state, loading: false };    
        
        case DELETE_PELVISPOSTURE:
            return { ...state, loading: false }; 
            
        case ALL_KNEEPOSTURE:
            return { ...state, loading: false, mkkneelists: action.payload };  
            
        case ADD_KNEEPOSTURE:
            return { ...state, loading: false }; 
        
        case EDIT_KNEEPOSTURE:
            return { ...state, loading: false };  
        
        case STATUS_KNEEPOSTURE:
            return { ...state, loading: false };    
        
        case DELETE_KNEEPOSTURE:
            return { ...state, loading: false };
            
        case ALL_FEETPOSTURE:
            return { ...state, loading: false, mkfeetlists: action.payload };  
            
        case ADD_FEETPOSTURE:
            return { ...state, loading: false }; 
        
        case EDIT_FEETPOSTURE:
            return { ...state, loading: false };  
        
        case STATUS_FEETPOSTURE:
            return { ...state, loading: false };    
        
        case DELETE_FEETPOSTURE:
            return { ...state, loading: false };

        case ALL_RHYTHMPOSTURE:
            return { ...state, loading: false, mkrythmlists: action.payload };  
            
        case ADD_RHYTHMPOSTURE:
            return { ...state, loading: false }; 
        
        case EDIT_RHYTHMPOSTURE:
            return { ...state, loading: false };  
        
        case STATUS_RHYTHMPOSTURE:
            return { ...state, loading: false };    
        
        case DELETE_RHYTHMPOSTURE:
            return { ...state, loading: false };  
            
        case ALL_ABBREVIATIONPOSTURE:
            return { ...state, loading: false, mkabbreviationlists: action.payload };  
            
        case ADD_ABBREVIATIONPOSTURE:
            return { ...state, loading: false }; 
        
        case EDIT_ABBREVIATIONPOSTURE:
            return { ...state, loading: false };  
        
        case STATUS_ABBREVIATIONPOSTURE:
            return { ...state, loading: false };    
        
        case DELETE_ABBREVIATIONPOSTURE:
            return { ...state, loading: false };      

        default: return { ...state };
    }
}